__webpack_require__.p = "https://asset-performance-fe.rc.securitize.io/";